import React from "react";
import translator from "@/translator";
import ResultView from "@/note_office/shared/ResultView";
import Bee from "@/note_office/icons/Bee.png";
import RedirectButton from "@/note_office/shared/RedirectButton";
const t = translator("note_office.views.chatter.index_view.");

const IndexView = ({ url, session_enabled, whatsapp_url }) => {
  const iframeStyles = `
      <link rel="stylesheet" type="text/css" href="/assets/note_office/note_office_iframe.css">
    `;

  const renderComponent = () => {
    if (!session_enabled) {
      return (
        <ResultView
          image={Bee}
          title={t("whatsapp.text")}
          buttons={[
            <RedirectButton
              key="main"
              type="primary"
              block
              className="button-base"
              url={whatsapp_url}
            >
              {t("whatsapp.button_text")}
            </RedirectButton>,
          ]}
        />
      );
    }
    return <iframe className="chatter-page__iframe" src={url} />;
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <div className="chatter-page">{renderComponent()}</div>
    </div>
  );
};

export default IndexView;
